import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarPrevious from './icon-calendar-previous.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarPrevious {...validProps} />;
}
SvgComponent.iconName = 'calendarPrevious';

export const CalendarPreviousIcon = svgIconWrapper(SvgComponent);
